import React from 'react';
import { Route, Switch } from 'react-router-dom';

import {
  accommodationItemRoute,
  activityItemRoute,
  dressCodeItemRoute,
  basicItemRoute,
  embedItemRoute,
  headlineItemRoute,
  livestreamItemRoute,
  newItemsRoute,
  paragraphItemRoute,
  personItemRoute,
  photoGalleryItemRoute,
  photoTimelineItemRoute,
  questionItemRoute,
  storyItemRoute,
  transportationItemRoute,
} from '../../helpers/routes';
import { AccommodationItem } from './AccommodationItem';
import { ActivityItem } from './ActivityItem';
import DressCodeItem from './DressCodeItem/';
import { BasicItem } from './BasicItem';
import { EmbedItem } from './EmbedItem';
import { HeadlineItem } from './HeadlineItem';
import { LivestreamItem } from './LivestreamItem';
import { PageItemSelector } from './PageItemSelector';
import { ParagraphItem } from './ParagraphItem';
import { PersonItem } from './PersonItem';
import PhotoGallery from './PhotoGallery';
import PhotoTimeline from './PhotoTimeline';
import { QuestionItem } from './QuestionItem';
import { StoryItem } from './StoryItem';
import { TransportationItem } from './TransportationItem';

interface PageItemRoutesProps {
  preview?: boolean;
  onSaveHandler?: () => void;
  onCloseHandler?: () => void;
  onBackHandler?: () => void;
}

const PageItemRoutes: React.FC<PageItemRoutesProps> = ({
  preview = false,
  onSaveHandler,
  onCloseHandler,
  onBackHandler,
  children,
}) => (
  <Switch>
    <Route path={newItemsRoute(':pageId', preview)}>
      <PageItemSelector preview={preview} leftButton={onCloseHandler !== undefined} onCloseHandler={onCloseHandler} />
    </Route>
    <Route path={headlineItemRoute(':pageId', ':itemId?', preview)}>
      <HeadlineItem onSaveHandler={onSaveHandler} />
    </Route>
    <Route path={paragraphItemRoute(':pageId', ':itemId?', preview)}>
      <ParagraphItem onSaveHandler={onSaveHandler} />
    </Route>
    <Route path={storyItemRoute(':pageId', ':itemId?', preview)}>
      <StoryItem onSaveHandler={onSaveHandler} />
    </Route>
    <Route path={personItemRoute(':pageId', ':itemId?', preview)}>
      <PersonItem />
    </Route>
    <Route path={photoGalleryItemRoute(':pageId', ':itemId?', preview)}>
      <PhotoGallery onSaveHandler={onSaveHandler} />
    </Route>
    <Route path={photoTimelineItemRoute(':pageId', ':itemId?', preview)}>
      <PhotoTimeline preview={preview} />
    </Route>
    <Route path={activityItemRoute(':pageId', ':itemId?', preview)}>
      <ActivityItem onSaveHandler={onSaveHandler} />
    </Route>
    <Route path={transportationItemRoute(':pageId', ':itemId?', preview)}>
      <TransportationItem onSaveHandler={onSaveHandler} />
    </Route>
    <Route path={accommodationItemRoute(':pageId', ':itemId?', preview)}>
      <AccommodationItem onSaveHandler={onSaveHandler} />
    </Route>
    <Route path={embedItemRoute(':pageId', ':itemId?', preview)}>
      <EmbedItem onSaveHandler={onSaveHandler} />
    </Route>
    <Route path={questionItemRoute(':pageId', ':itemId?', preview)}>
      <QuestionItem onSaveHandler={onSaveHandler} />
    </Route>
    <Route path={dressCodeItemRoute(':pageId', ':itemId?', preview)}>
      <DressCodeItem onSaveHandler={onSaveHandler} />
    </Route>
    <Route path={livestreamItemRoute(':pageId', ':itemId?', preview)}>
      <LivestreamItem onSaveHandler={onSaveHandler} />
    </Route>
    <Route path={basicItemRoute(':pageId', ':itemId', preview)}>
      <BasicItem onSaveHandler={onSaveHandler} />
    </Route>
    {children}
  </Switch>
);

export default PageItemRoutes;
